import React from 'react';
import styled from '@emotion/styled';
import 'external-svg-loader';

import { ComponentStyle, ProductComponentProps } from '../../types/types';

import VerticalSplit from '../shared/containers/VerticalSplit';
import { LinkHeader } from './LinkHeader';
import { LinkImage } from './LinkImage';
import { IconButton } from './IconButton';
import { LinkButton } from './LinkButton';

import { productComponentContainerPaddingStyle, productComponentContainerBottomPaddingStyle } from '../shared/styles';

import { StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

const LinkContentContainer = styled.div(productComponentContainerPaddingStyle, productComponentContainerBottomPaddingStyle, {
  alignItems: 'flex-start',
  justifyContent: 'center',

  '& h2': {
    color: 'var(--color-primary)',
  },

  '&.D': {
    // NOTE: if the colour needs to be dynamic then we could use the colour set in the product data. i.e. palette.
    backgroundColor: 'var(--color-light)',
  },

  [mqBreakpoints.desktop]: {
    paddingTop: pxToRem(96),
  },
});

export const Link: React.FC<ProductComponentProps> = props => {
  const { title, description, cta, style, image } = props.productComponent;
  const componentIdx = props.index ?? 0;

  return (
    <VerticalSplit id={`mp-product-link-${componentIdx}`} rowReverse={style === ComponentStyle.B || style === ComponentStyle.D} data-testid={'mp-product-link'}>
      {image && <LinkImage image={image} />}
      <LinkContentContainer className={style} style={image ? {} : { width: '100%' }}>
        <LinkHeader title={title} strapline={description} />
        {style === ComponentStyle.A || style === ComponentStyle.B ? <IconButton text={cta.buttonText} cta={cta.cta} /> : <LinkButton text={cta.buttonText} cta={cta.cta} />}
      </LinkContentContainer>
    </VerticalSplit>
  );
};
